import * as actions from '../actions/applicationAcceptedStatusesTransitions';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function getAcceptedStatusesTransitions(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.RECEIVE_LOG_IN_RESPONSE && !(action.payload.body.roles.includes('Administrator') && action.payload.body.roles.length == 1))
		.map(action => ({
			url: BASE_URL + 'api/applications/statuses/transitions' ,
			category: 'applicationAcceptedStatusesTransitions',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('applicationAcceptedStatusesTransitions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveApplicationAcceptedStatusesTransitions(JSON.parse(response.text)));
	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetAcceptedStatusesTransitions(sources) {
	let httpResponse$ = sources.HTTP
		.select('applicationAcceptedStatusesTransitions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestApplicationAcceptedStatusesTransitions([]));

	return {
		ACTION: httpResponse$
	}
}